import { IssueFront, Page, DatatableMessage } from '../../models/api.models';

export class IssueReviewPresaleData {
    issuesFront: IssueFront[];
    page: Page;
    idsFilterIssues: number[];
    loading: boolean;
    msg: DatatableMessage;
    selected: IssueFront[];
}
